// Styles
import styles from './VirtualizedStickyHeader.module.css';

/**
 *
 * @param {object} params
 * @param {React.ReactNode} params.children - Children to render
 * @param {number} [params.top=0] - Sticky offset from the top of the scrollport
 * @returns {JSX.Element} VirtualizedStickyHeader component
 */
function VirtualizedStickyHeader({ children, top = 0 }) {
  return (
    <div
      className={styles['virtualized-sticky-header']}
      style={{ top: `${top}px` }}
    >
      {children}
    </div>
  );
}

export default VirtualizedStickyHeader;
